import { render } from "./SmallModalContainer.vue?vue&type=template&id=6657a514&scoped=true"
import script from "./SmallModalContainer.vue?vue&type=script&lang=js"
export * from "./SmallModalContainer.vue?vue&type=script&lang=js"

import "./SmallModalContainer.vue?vue&type=style&index=0&id=6657a514&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6657a514"]])

export default __exports__